<div>
    <span class="example-pizza-party" matSnackBarLabel value="center">
        Successfully logged out from application
    </span>
</div>